import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  input,
  output,
} from '@angular/core';

import { PadStartPipe } from '@coworkrz/shared/misc';

@Component({
  selector: 'ui-timer',

  imports: [CommonModule, PadStartPipe],
  templateUrl: './timer.component.html',
})
export class TimerComponent implements OnInit, OnChanges {
  readonly isOpenSpace = input(false);
  hours: number[] = [];
  minutes: number[] = [];
  @Input() currentHour: number;
  @Input() currentMinute: number;
  readonly availableSlots = input<
    {
      startTime: string;
      endTime: string;
    }[]
  >([]);
  today = new Date();

  readonly bookingDay = input<Date>(new Date());
  readonly currentTime = output<{
    hour: number;
    minute: number;
  }>();

  ngOnInit() {
    this.populateHours();
    this.populateMinutes();
  }

  getDateTime(value: string): Date {
    const date = new Date();
    date.setHours(Number(value.split(':')[0]), Number(value.split(':')[1]));
    return date;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bookingDay']) {
      if (
        this.bookingDay().getDate() === this.today.getDate() &&
        this.bookingDay().getMonth() === this.today.getMonth()
      ) {
        this.currentTime.emit({
          hour: this.bookingDay().getHours(),
          minute: this.bookingDay().getMinutes(),
        });
        this.populateHours();
        this.populateMinutes();
        this.setCurrentHour(this.currentHour);
        this.setCurrentMinute(this.currentMinute);
      } else {
        this.currentTime.emit({
          hour: new Date().getHours(),
          minute: new Date().getMinutes(),
        });
        this.populateHours();
        this.populateMinutes();
        this.setCurrentHour(this.currentHour);
        this.setCurrentMinute(this.currentMinute);
      }
    }
  }

  getFreeSlotsDates() {
    const freeSlotsDates = this.availableSlots().map((slot) => {
      return {
        startTime: this.getDateTime(slot.startTime),
        endTime: this.getDateTime(slot.endTime),
      };
    });

    return freeSlotsDates;
  }

  populateHoursConditions(isToday: boolean, isSaturday: boolean) {
    const freeSlotsDates = this.getFreeSlotsDates();

    if (isSaturday) {
      if (isToday) {
        for (let i = this.today.getHours(); i < 15; i++) {
          for (let index = 0; index < freeSlotsDates.length; index++) {
            if (
              i >= freeSlotsDates[index].startTime.getHours() &&
              i <= freeSlotsDates[index].endTime.getHours() - 1
            ) {
              this.hours.push(i);
            }
          }
        }
      } else {
        for (let i = 8; i < 15; i++) {
          for (let index = 0; index < freeSlotsDates.length; index++) {
            if (
              i >= freeSlotsDates[index].startTime.getHours() &&
              i <= freeSlotsDates[index].endTime.getHours() - 1
            ) {
              this.hours.push(i);
            }
          }
        }
      }
    } else {
      if (this.today.getDate() === this.bookingDay().getDate()) {
        for (let i = this.today.getHours(); i < 19; i++) {
          for (let index = 0; index < freeSlotsDates.length; index++) {
            if (
              i >= freeSlotsDates[index].startTime.getHours() &&
              i <= freeSlotsDates[index].endTime.getHours() - 1
            ) {
              this.hours.push(i);
            }
          }
        }
      } else {
        for (let i = 8; i < 19; i++) {
          for (let index = 0; index < freeSlotsDates.length; index++) {
            if (
              i >= freeSlotsDates[index].startTime.getHours() &&
              i <= freeSlotsDates[index].endTime.getHours() - 1
            ) {
              this.hours.push(i);
            }
          }
        }
      }
    }
  }

  populateHours() {
    this.hours = [];

    // check if the booking day is saturday
    if (this.bookingDay().getDay() === 6 || this.today.getDay() === 6) {
      if (this.isOpenSpace()) {
        if (this.today.getDate() === this.bookingDay().getDate()) {
          for (let i = this.today.getHours(); i < 15; i++) {
            this.hours.push(i);
          }
        } else {
          for (let i = 8; i < 15; i++) {
            this.hours.push(i);
          }
        }
      } else {
        if (this.today.getDate() === this.bookingDay().getDate()) {
          this.populateHoursConditions(true, true);
        } else {
          this.populateHoursConditions(false, true);
        }
      }
    } else {
      if (this.isOpenSpace()) {
        if (this.today.getDate() === this.bookingDay().getDate()) {
          for (let i = this.today.getHours(); i < 19; i++) {
            this.hours.push(i);
          }
        } else {
          for (let i = 8; i < 19; i++) {
            this.hours.push(i);
          }
        }
      } else {
        if (this.today.getDate() === this.bookingDay().getDate()) {
          this.populateHoursConditions(true, false);
        } else {
          this.populateHoursConditions(false, false);
        }
      }
    }
  }

  populateMinutes() {
    this.minutes = [];
    let freeSlotsDates: { startTime: Date; endTime: Date }[] = [];

    const isOpenSpace = this.isOpenSpace();
    if (!isOpenSpace) {
      freeSlotsDates = this.getFreeSlotsDates();
    }

    if (
      this.today.getHours() === this.currentHour &&
      this.today.getDate() === this.bookingDay().getDate() &&
      this.today.getMonth() === this.bookingDay().getMonth() &&
      this.today.getFullYear() === this.bookingDay().getFullYear()
    ) {
      for (
        let i = this.getCurrentMinute(this.today.getMinutes());
        i < 60;
        i = i + 15
      ) {
        this.minutes.push(i);
      }
      this.setCurrentMinute(this.getCurrentMinute(this.today.getMinutes()));
    } else {
      if (!isOpenSpace) {
        for (let j = 0; j < freeSlotsDates.length; j++) {
          if (
            this.currentHour >= freeSlotsDates[j].startTime.getHours() &&
            this.currentHour === freeSlotsDates[j].endTime.getHours() - 1
          ) {
            this.minutes.push(freeSlotsDates[j].endTime.getMinutes());
            this.setCurrentMinute(
              this.getCurrentMinute(freeSlotsDates[j].endTime.getMinutes())
            );
            break;
          } else if (
            this.currentHour === freeSlotsDates[j].startTime.getHours()
          ) {
            this.setCurrentMinute(
              this.getCurrentMinute(freeSlotsDates[j].startTime.getMinutes())
            );
            for (
              let i = freeSlotsDates[j].startTime.getMinutes();
              i < 60;
              i = i + 15
            ) {
              this.minutes.push(i);
            }
          }
        }
        if (this.minutes.length === 0) {
          this.setCurrentMinute(0);
          for (let i = 0; i < 60; i = i + 15) {
            this.minutes.push(i);
          }
        }
      } else {
        if (this.bookingDay().getDay() === 6) {
          if (this.currentHour == 14) {
            this.setCurrentMinute(0);
            this.minutes.push(0);
            return;
          } else {
            this.setCurrentMinute(0);
            for (let i = 0; i < 60; i = i + 15) {
              this.minutes.push(i);
            }
          }
        } else {
          if (this.currentHour == 18) {
            this.setCurrentMinute(0);
            this.minutes.push(0);
            return;
          } else {
            this.setCurrentMinute(0);
            for (let i = 0; i < 60; i = i + 15) {
              this.minutes.push(i);
            }
          }
        }
      }
    }
  }

  getCurrentMinute(minute: number) {
    if (minute === 0) {
      return 0;
    } else if (minute <= 15) {
      return 15;
    } else if (minute <= 30) {
      return 30;
    } else if (minute <= 45) {
      return 45;
    } else {
      return 0;
    }
  }

  setCurrentHour(hour: number): void {
    this.currentHour = hour;
    this.populateMinutes();
    this.currentTime.emit({ hour, minute: this.currentMinute });
  }

  setCurrentMinute(minute: number): void {
    this.currentMinute = minute;
    this.currentTime.emit({ hour: this.currentHour, minute });
  }
}
